'use strict';

export default {
    getTree() {
        return new Promise((resolve, reject) => {
            axios({
              method: "GET",
              url: "/api/categories/tree",
              headers: {
                Accept: "application/json"
              }
            })
            .then(response => {
                resolve(response);
            })
            .catch(errors => {
                reject(errors.response.data);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Services/Categories.js